// Initialize all .mdl-audio__swiper Swipers
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
import { a11y } from './config/a11y';

export function initSwiperAudio() {
    const elements = document.querySelectorAll('.mdl-audio__swiper');
    if (!elements.length) return null;

    const instances = [];

    elements.forEach((el) => {
        // Find navigation buttons and pagination in parent container
        const audioWrapper = el.closest('.mdl-audio__wrapper');
        const rowContainer = el.closest('.row');
        const nextButton = rowContainer ? rowContainer.querySelector('.swiper-button-next') : null;
        const prevButton = rowContainer ? rowContainer.querySelector('.swiper-button-prev') : null;
        const pagination = el.querySelector('.swiper-pagination');

        const entryCount = parseInt(el.dataset.entries ?? '0', 10);
        const hasMultiple = entryCount >= 2;

        const instance = new Swiper(el, {
            modules: [Navigation, Pagination, A11y, Keyboard],
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 30,
            autoHeight: true,

            // No loop for audio entries
            loop: false,

            // Accessibility
            a11y,

            // Keyboard navigation (initially disabled)
            keyboard: {
                enabled: false,
                onlyInViewport: true
            },

            // Touch/Mouse behavior
            grabCursor: true,
            touchRatio: 1,
            touchAngle: 45,

            // Performance
            watchSlidesProgress: true,
            preloadImages: false,
            lazy: false,

            // Responsive breakpoints
            breakpoints: hasMultiple ? {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 30
                }
            } : {},

            // Navigation
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
                disabledClass: 'swiper-button-disabled'
            },

            // Pagination
            pagination: {
                el: pagination,
                clickable: true,
                type: 'bullets'
            },

            // Pause all audio when slide changes
            on: {
                slideChange: function (swiper) {
                    const allAudio = swiper.el.querySelectorAll('audio');
                    allAudio.forEach(audio => {
                        audio.pause();
                    });
                }
            }
        });

        // Enable keyboard navigation only when swiper is focused or hovered
        const enableKeyboard = () => instance.keyboard.enable();
        const disableKeyboard = () => instance.keyboard.disable();

        el.addEventListener('mouseenter', enableKeyboard);
        el.addEventListener('mouseleave', disableKeyboard);
        el.addEventListener('focusin', enableKeyboard);
        el.addEventListener('focusout', disableKeyboard);

        instances.push(instance);
    });

    return instances;
}
